<template>
    <div class="modal fade register-success" id="updatePasswordSuccess" tabindex="-1" role="dialog" aria-labelledby="updatePasswordSuccessLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content text-center">
            <div class="modal-body">
                <h5 class="modal-title">Your password has been changed successfully</h5>
                <ColoredButton class="mt-3" data-dismiss="modal" @click="scrollToTop">OK</ColoredButton>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ColoredButton from './ColoredButton';
    export default {
        components: {
            ColoredButton
        },
        computed: {
            contactDetails() {
                return this.$store.getters['GET_FOOTER_SETTINGS']; 
            }
        },
        mounted() {
            this.$store.dispatch('footerSettings');
        },
        methods : {
            scrollToTop(){
                window.scrollTo(0,0)
            }
        }
    }
</script>